import { CommonModule } from '@angular/common';
import { Component, ElementRef, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild, AfterViewInit, OnDestroy } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faXmark } from '@fortawesome/pro-light-svg-icons';
import { DeactivationSource, UserDeactivationBlocker } from '../../core/models/user-deactivation-blocker.model';

@Component({
  selector: 'app-user-deactivation-blocked-modal',
  standalone: true,
  imports: [CommonModule, RouterModule, FontAwesomeModule],
  templateUrl: './user-deactivation-blocked-modal.component.html',
  styleUrl: './user-deactivation-blocked-modal.component.scss'
})
export class UserDeactivationBlockedModalComponent implements OnChanges, AfterViewInit, OnDestroy {
  @Input() clients: UserDeactivationBlocker[] = [];
  @Output() closeEvent = new EventEmitter<void>();

  faXmark = faXmark;

  @ViewChild('closeButton') closeButton?: ElementRef<HTMLButtonElement>;

  private previouslyFocusedElement: HTMLElement | null = null;

  ngOnChanges(changes: SimpleChanges) {
    if (changes['clients'] && this.clients.length > 0) {
      this.previouslyFocusedElement = document.activeElement as HTMLElement;
    }
  }

  ngAfterViewInit() {
    this.closeButton?.nativeElement.focus();
  }

  ngOnDestroy() {
    this.previouslyFocusedElement?.focus();
  }

  onClose() {
    this.closeEvent.emit();
  }

  getClientName(client: UserDeactivationBlocker): string {
    if (client.personType === 'PHYSICAL_PERSON') {
      return [
        client.firstSurname,
        client.secondSurname,
        client.name,
      ].filter(Boolean).join(' ');
    }
    return client.name ?? '';
  }

  getOrderedSources(client: UserDeactivationBlocker): DeactivationSource[] {
    const order: DeactivationSource[] = ['INTERNO', 'DECLARACIONES'];
    return order.filter(source => client.sources?.includes(source));
  }

  getSourceLabel(source: DeactivationSource): string {
    return source === 'INTERNO' ? 'Interno' : 'Declaraciones';
  }

  getClientTab(client: UserDeactivationBlocker): string | undefined {
    if (client.sources.length === 1) {
      return client.sources[0] === 'INTERNO' ? 'workTeam' : 'declarations';
    }
    return undefined;
  }

  getSourceLabels(client: UserDeactivationBlocker): string {
    return this.getOrderedSources(client).map(source => this.getSourceLabel(source)).join(', ');
  }

  getClientLink(client: UserDeactivationBlocker): (string | number)[] {
    return ['/clients/detail', client.id];
  }

  getClientQueryParams(client: UserDeactivationBlocker): { clientTab?: string } {
    const tab = this.getClientTab(client);
    return tab ? { clientTab: tab } : {};
  }
}
